// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"230":"56fdd49f","279":"1fd3c50f"}[chunkId] + ".js";
};